import { QUERY} from './QueryTypes'

const initialState = {
    query: {layer: "",action:null}
}

const query = (state = initialState, action) => {
    
    switch (action.type) {
        case QUERY:
            
            return {
                query: action.load
            }
    
        default:
          return state
    }

}

export default query;